<template>
  <div>
    <div>
      <template v-if="datas.length > 0">
        <project-item
          v-for="(item,index) in datas"
          :key="index"
          :pro-item-data="item"
          :cid="$route.query.cid * 1"
          :baseinfo="baseinfo"
        />
        <div
          v-if="baseinfo.isadmin===1 || baseinfo.isfounder===1"
          class="create-box"
        >
          <cube-button
            :light="true"
            @click="creatPro"
          >
            {{ $t('message["127"]') }}
          </cube-button>
        </div>
      </template>
      <div
        v-else
        class="empty-pro-box"
      >
        <img src="../../assets/images/empty.png">
        <p>
          <cube-button
            v-if="(baseinfo.isadmin===1 || baseinfo.isfounder===1) && isBtn"
            :primary="true"
            @click="creatPro"
          >
            {{ $t('message["127"]') }}
          </cube-button>
        </p>
        <!-- <div
          class="loading"
        >
          <cube-loading :size="40" />
        </div> -->
      </div>
    </div>
    <!-- <div
      v-else
      class="loading"
    >
      <cube-loading :size="40" />
    </div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProjectItem from './ProjectItem'
export default {
  components: {
    ProjectItem
  },
  props: {
    datas: {
      type: Array,
      default () {
        return []
      }
    },
    baseinfo: {
      type: Object,
      default () {
        return {}
      }
    },
    isBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ishidden: 0,
      obj: {},
      isProjectListReady: false
    }
  },
  computed: {
    ...mapState('organization/org', ['datasReady']),
    // projectListDatas () {
    //   let obj = {}
    //   const { datas } = this
    //   const cid = this.$route.query.cid
    //   for (let[key, value] of Object.entries(datas)) {
    //     if (key * 1 === cid * 1) {
    //       obj = value.projects
    //     }
    //   }
    //   return obj
    // },
    page () {
      return this.$route.query.page
    }
  },
  async mounted () {
    // const cid = this.$route.query.cid
    // const chain = await this.fetchProjectList({ cid })
    // chain.onSuccess((data, res) => {
    //   for (let [key, value] of Object.entries(data)) {
    //     if (key * 1 === cid * 1) {
    //       this.obj = Object.assign({}, value.projects)
    //       this.baseinfo = {
    //         isfounder: value.isfounder,
    //         isadmin: value.isadmin,
    //         comname: value.comname
    //       }
    //     }
    //   }
    //   this.isProjectListReady = true
    // })
    //   .fetch()
  },
  methods: {
    ...mapActions('organization/org', ['fetchProjectList']),
    creatPro () {
      this.$router.push({
        name: 'ProjectIndexPc',
        query: {
          page: 3,
          cid: this.$route.query.cid,
          type: this.$route.query.type || 'inquery'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.empty-pro-box {
  width:273px;
  margin: 130px auto 0;
  img{
    width: 273px;
    height: 205px;
  }
}
.create-box {
  margin: 0 12px;
}
</style>
